import { render, staticRenderFns } from "./ProgramInquriy.vue?vue&type=template&id=c71df602"
import script from "./ProgramInquriy.vue?vue&type=script&lang=js"
export * from "./ProgramInquriy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports